import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  offers: [],
  myOffers: [],
  vendorOffers: [],
  adminOffers: [],
  total: 0,
  pages: 0,
  error: null,
  success: false,
  message: null,
};

export const offerReducer = createReducer(initialState, {
  submitOfferRequest: (state) => { state.isLoading = true; },
  submitOfferSuccess: (state, action) => {
    state.isLoading = false;
    state.success = true;
    state.myOffers = [...state.myOffers, action.payload];
  },
  submitOfferFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  getMyOffersRequest: (state) => { state.isLoading = true; },
  getMyOffersSuccess: (state, action) => {
    state.isLoading = false;
    state.myOffers = action.payload;
  },
  getMyOffersFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  cancelOfferRequest: (state) => { state.isLoading = true; },
  cancelOfferSuccess: (state, action) => {
    state.isLoading = false;
    state.success = true;
    state.message = action.payload.message;
    state.myOffers = state.myOffers.map((o) =>
      o._id === action.payload.id ? { ...o, status: "cancelled" } : o
    );
  },
  cancelOfferFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  getAdminOffersRequest: (state) => { state.isLoading = true; },
  getAdminOffersSuccess: (state, action) => {
    state.isLoading = false;
    state.adminOffers = action.payload.offers;
    state.total = action.payload.total;
    state.pages = action.payload.pages;
  },
  getAdminOffersFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  adminReviewOfferRequest: (state) => { state.isLoading = true; },
  adminReviewOfferSuccess: (state, action) => {
    state.isLoading = false;
    state.success = true;
    state.adminOffers = state.adminOffers.map((o) =>
      o._id === action.payload._id ? action.payload : o
    );
  },
  adminReviewOfferFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  getVendorOffersRequest: (state) => { state.isLoading = true; },
  getVendorOffersSuccess: (state, action) => {
    state.isLoading = false;
    state.vendorOffers = action.payload;
  },
  getVendorOffersFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  vendorRespondOfferRequest: (state) => { state.isLoading = true; },
  vendorRespondOfferSuccess: (state, action) => {
    state.isLoading = false;
    state.success = true;
    state.vendorOffers = state.vendorOffers.map((o) =>
      o._id === action.payload._id ? action.payload : o
    );
  },
  vendorRespondOfferFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  clearOfferErrors: (state) => { state.error = null; },
  clearOfferSuccess: (state) => { state.success = false; state.message = null; },
});
